import React, { useState } from 'react';
import { Modal, Header, Button } from 'semantic-ui-react';

import SelectSitesTable from 'Common/SelectSitesTable';

const additionalColumns = [
  {
    Header: 'Last Shared On',
    resizable: false,
    headerStyle: {
      textAlign: 'center',
      marginLeft: 0,
      display: 'flex',
      alignItems: 'center',
      padding: '7px 0',
    },
    id: 'LastSharedOnDT',
    sortable: true,
    filterable: false,
    accessor: 'LastSharedOnDT',
  },
];

export const SharedMenusModal = ({
  sharedItemDescription,
  showSharedMenusModal,
  onShareModalClose,
  onShare,
  onUnshare,
  sharedDistricts,
  sharedItemId,
  loading,
  handleOpen,
}) => {
  const [selectedToShare, setSelectedToShare] = useState([]);

  const areAnySelectedNotAlreadyShared = () => {
    const allSelectedHaveBeenShared = selectedToShare.every((districtId) => {
      return sharedDistricts.some((district) => {
        return district.Id === districtId && district.LastSharedOnDT !== null;
      });
    });

    return !allSelectedHaveBeenShared;
  };

  return (
    <Modal
      open={showSharedMenusModal}
      onMount={handleOpen}
      onClose={() => {
        onShareModalClose();
        setSelectedToShare([]);
      }}
      size="large"
      closeIcon
    >
      <Header content={sharedItemDescription} />
      <Modal.Content scrolling>
        <SelectSitesTable
          additionalColumns={additionalColumns}
          selectDistrictMode={true}
          fetchSites={false}
          loading={loading}
          sites={sharedDistricts}
          onChange={(selectedDistricts) => {
            setSelectedToShare(selectedDistricts);
          }}
        />
      </Modal.Content>

      <Modal.Actions>
        <Button
          color="orange"
          content="Unshare"
          size="big"
          disabled={
            selectedToShare.length === 0 ||
            loading ||
            areAnySelectedNotAlreadyShared()
          }
          onClick={() => onUnshare(sharedItemId, selectedToShare)}
          loading={loading}
        />
        <Button
          color="orange"
          content="Share"
          size="big"
          disabled={selectedToShare.length === 0 || loading}
          onClick={() => onShare(sharedItemId, selectedToShare)}
          loading={loading}
        />
      </Modal.Actions>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/pages/managemenu/components/SharedMenusModal.js